<div class="modal-header">
  <h4 class="modal-title" [id]="titleId">{{ 'layout.mobileAppModal.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'layout.mobileAppModal.close' | translate"
    (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted text-center mb-3 d-none d-md-block">{{ 'layout.mobileAppModal.subtitleDesktop' | translate }}</p>
  <p class="text-muted text-center mb-3 d-md-none">{{ 'layout.mobileAppModal.subtitleMobile' | translate }}</p>

  <div class="row g-3">
    @for (store of stores; track store.id) {
    <div class="col-md-6">
      <div class="card border shadow-none h-100 mb-0">
        <div class="card-body text-center p-3">
          <h5 class="mt-0 mb-2">{{ store.devicesKey | translate }}</h5>
          <!-- A phone cannot scan its own screen, so the QR only shows from md up. The svg renderer ignores
               [ariaLabel], so the accessible name lives on the wrapper; the white tile keeps it scannable in dark mode. -->
          <div class="d-none d-md-inline-flex bg-white border rounded-3 p-1 mb-2" role="img"
            [attr.aria-label]="store.qrKey | translate">
            <qrcode [qrdata]="store.url" [width]="120" [margin]="2" [errorCorrectionLevel]="qrErrorLevel"
              [elementType]="qrElementType" [cssClass]="'d-flex'" />
          </div>
          <!-- Official badge, unmodified, 40px tall (Apple and Google minimums) -->
          <a class="d-block" [href]="store.url" target="_blank" rel="noopener noreferrer">
            <img [src]="store.badgeSrc" height="40" [alt]="store.badgeAltKey | translate" />
            <span class="visually-hidden">{{ 'layout.mobileAppModal.opensInNewTab' | translate }}</span>
          </a>
        </div>
      </div>
    </div>
    }
  </div>
</div>

<div class="modal-footer justify-content-between flex-nowrap">
  <small class="text-muted text-start">{{ 'layout.mobileAppModal.trademarks' | translate }}</small>
  <button type="button" class="btn btn-light" (click)="close()">
    {{ 'layout.mobileAppModal.close' | translate }}
  </button>
</div>
